import React from "react";
import Lottie from "react-lottie";
import * as animationData from "./worldanimation.json";

export default class World extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isStopped: false, isPaused: false };
  }

  render() {
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: animationData,
      rendererSettings: {}
    };

    return (
      <div>
        <Lottie
          options={defaultOptions}
          height={"90vh"}
          width={"90vw"}
          isStopped={false}
          isPaused={false}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/world.js